export default __webpack_public_path__ + "static/media/offerings.64bca2dd.svg";